import Api from '@/plugins/Api'
import { IProject } from '@/types/Projects'

class ProjectsService {
  async fetchAll() {
    try {
      const res = await Api.get<IProject[]>('/projects')

      return res
    } catch (e) {
      return []
    }
  }

  async fetchById(projectId: string) {
    try {
      const res = await Api.get<IProject>(`/projects/${projectId}`)

      return res
    } catch (e) {
      return null
    }
  }
}

export default new ProjectsService()
